import {USED_AS_CARD} from '~/common/utils/event_constants';
import {isFabricWebview} from '~/common/utils/webview';

export const isInCheckoutABTest = () =>
  evite.experiments.inVariation('test_exp-expanded_pro_checkout', 'variant', false);

export const isInExpandedCheckoutABTest = (
  classifiedCategory: string,
  eventStatus: string,
  inUpsellMode: boolean
): boolean => {
  if (
    (eventStatus !== 'sending' || inUpsellMode) &&
    classifiedCategory &&
    classifiedCategory.toLowerCase().includes('birthday')
  )
    return evite.experiments.inVariation('test_pricing_expanded_checkout', 'variant', false);
  return false;
};

export const isInCreateFlowNavABTest = (readOnly = true) => {
  if (isFabricWebview() || window.fabricTemplate.used_as === USED_AS_CARD) return false;
  evite.experiments.getOrSetVariation('test_create_flow_nav', 'control', readOnly);
  return evite.experiments.inVariation('test_create_flow_nav', 'variant');
};
